import { FC } from 'react';

import SelectInput from 'components/primitives/SelectInput';
import SelectOption from 'components/primitives/SelectOption';
import { Form, Formik, useFormikContext } from 'formik';
import { UserLocationFormViewProps } from './UserLocationForm.props';

const UserLocationFormView: FC<UserLocationFormViewProps> = ({
  controller,
  formModeOff = false,
  hideLabels,
  cityName,
  stateName,
}) => {
  const {
    onSubmit,
    isLoading = false,
    states,
    cities,
    onChangeState,
    selectedCityId,
    selectedStateId,
  } = controller!;

  const initialData = {
    state: selectedStateId,
    location: selectedCityId,
    address: selectedCityId,
  };

  const LocationInputElements = () => {
    const formik = useFormikContext();
    return (
      <div className="flex w-full items-start gap-x-4 justify-start lg:flex-row flex-col">
        <div className="md:w-full lg:w-[80%] w-full mx-auto md:mx-0">
          <SelectInput
            isRequired
            defaultValue={selectedStateId}
            onChange={onChangeState}
            label={hideLabels ? '' : 'State'}
            key="states"
            name={stateName ?? 'state'}
            placeholder="Select State">
            {states.length > 0 && <option>Select State</option>}
            {states.map((state, index) => {
              return (
                <SelectOption
                  key={state._id + index}
                  value={state._id}
                  child={state.title!}
                />
              );
            })}
          </SelectInput>
        </div>
        <div className="md:w-full lg:w-[80%] w-full mx-auto md:mx-0">
          <SelectInput
            isRequired
            label={hideLabels ? '' : 'City'}
            defaultValue={selectedCityId}
            onChange={(value: string) => {
              formik.setFieldValue(cityName ?? 'address', value);
              if (!formModeOff) {
                formik.submitForm();
              }
            }}
            key="cities"
            name={cityName ?? 'address'}
            placeholder="Select City">
            {cities.length > 0 && <option>Select City</option>}
            {cities.map((city, index) => {
              return (
                <SelectOption
                  selected={selectedCityId === city._id}
                  key={city._id + index}
                  value={city._id}
                  child={city.title!}
                />
              );
            })}
          </SelectInput>
        </div>
        {/* {!formModeOff && (
          <Button
            className="rounded-lg"
            id="open-btn"
            type="submit"
            isLoading={isLoading}
            variant="solid"
            colorScheme="primary">
            Save
          </Button>
        )} */}
      </div>
    );
  };

  return (
    <div className="w-full">
      {!formModeOff ? (
        <Formik initialValues={initialData} onSubmit={onSubmit}>
          <Form>
            <LocationInputElements />
          </Form>
        </Formik>
      ) : (
        <LocationInputElements />
      )}
    </div>
  );
};

export default UserLocationFormView;
